import img from "../../../img/maxbox.webp";
export const cardBox = [
  {
    img: img,
    name: "Maxi BOX Tradition",
    text: "Original sandwich, fries, 0.4 l coca cola, sauce to choose from",
    price: "45 000 sum",
  },
  {
    img: img,
    name: "Maxi BOX Tradition",
    text: "Original sandwich, fries, 0.4 l coca cola, sauce to choose from",
    price: "45 000 sum",
  },
  {
    img: img,
    name: "Maxi BOX Tradition",
    text: "Original sandwich, fries, 0.4 l coca cola, sauce to choose from",
    price: "45 000 sum",
  },
  {
    img: img,
    name: "Maxi BOX Tradition",
    text: "Original sandwich, fries, 0.4 l coca cola, sauce to choose from",
    price: "45 000 sum",
  },
  {
    img: img,
    name: "Maxi BOX Tradition",
    text: "Original sandwich, fries, 0.4 l coca cola, sauce to choose from",
    price: "45 000 sum",
  },
  {
    img: img,
    name: "Maxi BOX Tradition",
    text: "Original sandwich, fries, 0.4 l coca cola, sauce to choose from",
    price: "45 000 sum",
  },
  
];
